'use client';

import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useParams } from 'next/navigation';

export default function Footer() {
  const t = useTranslations('common');
  const footerT = useTranslations('footer');
  const params = useParams();
  const locale = params.locale as string;

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Logo ve Açıklama */}
          <div>
            <h5 className="text-lg font-bold mb-4 font-serif">TRİNK EMLAK</h5>
            <p className="text-gray-400 leading-relaxed">
              {footerT('companyDescription')}
            </p>
          </div>
          
          {/* Hızlı Bağlantılar */}
          <div>
            <h5 className="text-lg font-bold mb-4 font-serif">{footerT('quickLinks')}</h5>
            <ul className="space-y-2">
              <li><Link href={`/${locale}/bilgi?bolum=hakkimizda`} prefetch={false} className="text-gray-400 hover:text-white transition-colors">{t('about')}</Link></li>
              <li><Link href={`/${locale}/muzayedeler`} prefetch={false} className="text-gray-400 hover:text-white transition-colors">{t('auctions')}</Link></li>
              <li><Link href={`/${locale}/bilgi?bolum=sss`} prefetch={false} className="text-gray-400 hover:text-white transition-colors">{footerT('faq')}</Link></li>
              <li><Link href={`/${locale}/bilgi?bolum=iletisim`} prefetch={false} className="text-gray-400 hover:text-white transition-colors">{t('contact')}</Link></li>
            </ul>
          </div>
          
          {/* Yasal */}
          <div>
            <h5 className="text-lg font-bold mb-4 font-serif">{footerT('legal')}</h5>
            <ul className="space-y-2">
              <li><Link href={`/${locale}/bilgi?sozlesme=uyelik-ve-kullanim`} prefetch={false} className="text-gray-400 hover:text-white transition-colors">{footerT('termsOfUse')}</Link></li>
              <li><Link href={`/${locale}/bilgi?sozlesme=cerez-politikasi`} prefetch={false} className="text-gray-400 hover:text-white transition-colors">{footerT('cookiePolicy')}</Link></li>
              <li><Link href={`/${locale}/bilgi?sozlesme=kvkk-aydinlatma-metni`} prefetch={false} className="text-gray-400 hover:text-white transition-colors">{footerT('kvkk')}</Link></li>
            </ul>
          </div>
          
          
          {/* Sosyal Medya */}
          <div>
            <h5 className="text-lg font-bold mb-4 font-serif">{t('followUs')}</h5>
            <div className="flex items-center space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center justify-center">
                <span className="material-icons">facebook</span>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center justify-center">
                <span className="text-2xl font-bold leading-none">X</span>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center justify-center">
                <span className="material-icons">camera_alt</span>
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400">© 2025 Trink Emlak. {t('allRightsReserved')}.</p>
        </div>
      </div>
    </footer>
  );
}
